<script>
import { Line } from 'vue-chartjs'

const colors = [
  '#25A4DF', // Blue
  '#44B469', // Green
  '#9AAEB9', // Gray
  '#E46651', // Red
  '#00D8FF', // Light Blue
  '#F87979', // Reddish Pink
  '#66D7D1', // Teal
  '#E6B89C', // Peach
  '#EAD2AC', // Tan
  '#9CAFB7', // Gray
  '#4281A4', // Dark Greenish-Blue
  '#C9683B', // Orange
  '#431B35', // Purple
  '#EF6461', // Pastel Red
  '#E4B363', // Earth Yellow
  '#313638', // Onyx
  '#5ADBFF', // Maya Blue
  '#FE9000', // Dark Orange
  '#466060', // Deep Space Sparkle
  '#0E0F19', // Smoky Black
  '#CBF7ED', // Aero Blue
  '#23395B', // Japanese Indigo
  '#CDE7B0', // Tea Green
  '#EF476F', // Infra Red
  '#26547C', // B'dazzled Blue
  '#1C3738', // Medium Jungle Green
  '#4C3957', // Pineapple (not pineapple)
  '#C68866', // Pale Copper
  '#F5F749', // Lemon yellow
  '#565554', // Davy's Grey
  '#F24236', // Vermilion
  '#84BCDA', // Dark Sky Blue
  '#F37748', // Mandarin
  '#7F7EFF', // Medium Slate Blue
  '#C69DD2', // Wisteria
  '#CC8B8C', // Puce
  '#593837', // Dark Liver (horses) -> Why on earth is this horse specific?
  '#CCC9E7' // Soap
]

export default {
  extends: Line,
  props: ['height', 'chartName', 'apiData', 'fieldData', 'valueField', 'demographicName', 'colorValues', 'demographicTotalKey'],
  data: function () {
    return {
      datasets: []
    }
  },
  computed: {
    chartData: function () {
      return this.values
    },
    labels: function () {
      let labels = []
      const apiLabels = _.keys(this.values)
      let shortLabels = false
      let labelLength = 20

      _.forEach(apiLabels, (apiLabel) => {
        if (this.values[apiLabel][0].demographic) {
          const matchingField = _.find(this.apiData, (f) => {
            return f.name === apiLabel
          })

          if (matchingField) {
            if (!shortLabels) {
              labels.push(matchingField.label)
            } else {
              labels.push(matchingField.label.substring(0, labelLength))
            }
          } else {
            if (!shortLabels) {
              labels.push(apiLabel.substring(0, labelLength))
            } else {
              labels.push(apiLabel)
            }
          }
        }
      })

      return labels
    },
    values: function () {
      // Setup the labels...
      Object.values(this.apiData).forEach((value) => {
        value.forEach((item, index) => {
          if (item.demographic) {
            if (this.datasets.filter(e => e.label === item.demographic).length === 0) {
              let color = colors[this.datasets.length - 1]

              if (this.colorValues) {
                let colorValue = this.colorValues.find(obj => obj.value === this.demographicName)
                if (colorValue) {
                  let colorData = colorValue.colors.find(obj => obj.name === item.demographic)
                  color = colorData ? colorData.color : color
                }
              }

              this.datasets.push({ label: item.demographic, data: [], backgroundColor: color, borderColor: color })
            }
          }
        })
      })

      let totalLength = 0

      // Setup the data for the labels...
      Object.values(this.apiData).forEach((value) => {
        totalLength += 1

        value.forEach((value, index) => {
          let valueDemographic = value.demographic
          let valueDemographicValue = !this.demographicTotalKey ? value.demographicTotal : value[this.demographicTotalKey]

          // Find it in the dataset and push it to the data...
          this.datasets.forEach((value, index) => {
            if (value.label === valueDemographic) {
              this.datasets[index].data.push(valueDemographicValue)
            }
          })
        })

        // See if we need to add a 0 to the dataset for this column...
        this.datasets.forEach((value, index) => {
          if (value.data.length !== totalLength) {
            value.data.push(0)
          }
        })

        // Remove the fill under each line
        this.datasets.forEach((value, index) => {
          value.fill = false
          value.lineTension = 0
        })
      })

      this.datasets.sort((a, b) => (a.label > b.label) ? 1 : ((b.label > a.label) ? -1 : 0))

      return this.apiData
    }
  },
  methods: {
    renderLineChart: function () {
      this.renderChart(
        // data
        {
          options: {
            legend: {
              display: true
            }
          },
          type: 'line',
          labels: this.labels,
          datasets: this.datasets
        },
        // options
        {
          legend: {
            display: true
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [{ stacked: false }],
            yAxes: [{
              stacked: false,
              ticks: {
                beginAtZero: true,
                precision: 0
              }
            }]
          }
        })
    }
  },
  watch: {
    apiData: function () {
      if (this.$data._chart) {
        this.$data._chart.destroy()
      }
      this.datasets = []
      this.renderLineChart()
    }
  },
  mounted () {
    this.renderLineChart()
  }
}
</script>


// WEBPACK FOOTER //
// src/views/charts/StackedLineChart.vue